import styled from 'styled-components'

export const Wrapper = styled.div`
  .ql-editor {
    font-size: ${(props) => props.fontSize};
  }
`
